import React, { useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Box, Button, IconButton, InputBase } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

//Hooks
import {useFetchData} from '../../../../hooks/useFetchData/useFetchData';
import CustomTableCell from '../../../shared/CustomTable/CustomTableCell';

let url = process.env.REACT_APP_API+ "/user/all";


export default function UsersTable(props) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filter, setFilter] = useState('');

  const { data : listUsers } = useFetchData(url, {table: true, filter: filter, page: page, rowsPerPage: rowsPerPage}, props.changed);
   
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    props.handleChanged();
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    props.handleChanged();
  };

  const handleEditUser = (values) =>{
    props.setValues(values);
    props.setEditing(true);
    props.setOpen(true);
  }

  const handleSetFilter = (filter) => {
    setFilter(filter.target.value);
  }

  const handleSearch = () => {
    props.handleChanged();
  }  
 

  const getStatus = (status) => {
    switch(status){
      case 0: return 'Inativo'; 
      case 1: return 'Ativo';
    } 
  }

  return (
    <Box>
      <Paper elevation={3} sx={{ p: '2px 4px', display: 'flex',  mb: 2, border: '1px solid rgba(0, 0, 0, 0)', ':hover': { border: '1px solid' } }}>
        <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder="Busque por Nome, Usuário ou Código"
            value={filter}
            onChange={handleSetFilter}
            onKeyDown={(e) => {if(e.key === "Enter")handleSearch()}}
        />
        <IconButton type="button" sx={{ p: '10px' }} title='Buscar' onClick={handleSearch}>
            <SearchIcon />
        </IconButton>
      </Paper >      
      <Paper sx={{ width: '100%', overflow: 'hidden' }}> 
        <TableContainer sx={{ overflow: 'scroll', height: '70vh'}}>
          <Table stickyHeader  sx={{ width: '100%' }}>
            <TableHead>
              <TableRow>
                  <CustomTableCell>Nome</CustomTableCell>
                  <CustomTableCell>Usuário</CustomTableCell>
                  <CustomTableCell>Grupo </CustomTableCell>    
                  <CustomTableCell align="center">Status</CustomTableCell>     
                  <CustomTableCell align="center">Editar</CustomTableCell>                                              
              </TableRow>
            </TableHead>
            <TableBody>
            {listUsers && listUsers.map((row) => (
              <TableRow key={row.id}>
                <CustomTableCell component="th" scope="row">
                  {row.name}
                </CustomTableCell>
                <CustomTableCell align="left">{row.user}</CustomTableCell>
                <CustomTableCell align="left">{row.group_name}</CustomTableCell>
                <CustomTableCell align="center">{getStatus(row.status)}</CustomTableCell>
                <CustomTableCell align="center">
                  <Button onClick={() => handleEditUser(row)}>
                      <EditOutlinedIcon />
                  </Button></CustomTableCell>
              </TableRow>
            ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          labelRowsPerPage='Registros por página'
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={(listUsers && listUsers) ? Math.ceil(listUsers[0]?.count) : 10}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{fontSize: '12px'}}
        />
      </Paper>
    </Box>
  );
}